import { useEffect } from 'react';
import { resetActivitySheetScroll } from './activity-sheet.utils';

export const useActivitySheetScrollReset = (id: number) => {
  useEffect(() => {
    resetActivitySheetScroll();
  }, [id]);
};
